/* eslint-disable max-len */
/**
 * refund-policy页面配置
 */
export default {
  title: 'Think Academy Refund Policy',
  content: `
    <p class="font-bold">A. How much refund can I get?</p>
    <span style="text-decoration: underline;">Refund for Regular Course:</span>
    <p>If the student drops the course after the first class and requests a refund before the second class, a 
      full refund of tuition, after deducting the registration fee and the textbook fee, if applicable, will be issued in the form of original payment. 
      If the student drops the course after the second class, we will deduct from the refund the prorated tuition 
      fee for classes attended, including the trial class, the registration fee, and the textbook fee, if applicable.</p>

    <span style="text-decoration: underline;">Refund for other courses and activities:</span>
    <p>Since there is no trial class provided for short term courses, activities or evaluation tests, 
    the refund for these courses will deduct the prorated tuition for classes attended and the Textbook Fee if applicable.</p>

    <p class="font-bold">B. What do I need to know before applying for a refund?</p>
    <p>Make sure to apply for the refund before the next scheduled class. Please note, 
    no refund will be credited to any passed or commenced classes. If classes started or ended before a refund request submitted, 
    a prorated tuition will be deducted from the refund, regardless of the student’s attendance of the class. 
    We will not refund for absence from class due to personal reasons. Courses that concluded are nonrefundable.</p>

    <p class="font-bold">C. Where should I submit a refund request?</p>
    <p>Parents could request a refund through the Think Academy app. 
    We could also assist with the refund at our service centers, 
    with the receipt and valid identification documents (passport, permanent residence card or driver’s license or other valid ID documents issued by the government).</p>

    <p class="font-bold">D. Methods of Refund</p>
    <span>A refund will be issued in the original form of payment.</span>
    <p>
      <span style="text-decoration: underline;">APP Refund:</span>Parents could apply for a refund using the Refund function in our Think Academy app. The refund will go back to the original payment method within 14 business days.
    </p>

    <p>
      <span style="text-decoration: underline;">Refund at the Service Center:</span>Parents could apply for a refund at our service center with the receipt and valid identification documents (driver’s license, passport, permanent resident card or other valid ID documents issued by the government).  The refund will go back to the original payment method within 14 business days.
    </p>

    <p class="font-bold">E. Non-Refundable Purchase</p>

    <p>Please note that, as an exception to our general refund policy outlined here in A through D, the following purchases are non-refundable:</p>

    <ol>
      <li>Textbook, ThinKit and other tangible items that may or may not accompanied by classes; (Please contact the customer service for an exchange if the product is defective.)</li>
      <li>Promotional classes and activities that are less than $10 dollars;</li>
      <li>Any rewards received based on the earned points.</li>
    </ol>
  `,
}
